export const appHead = {"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"apple-touch-icon","type":"image/png","href":"/apple-touch-icon-precomposed.png"},{"rel":"apple-touch-icon-precomposed","type":"image/png","href":"/apple-touch-icon-precomposed.png"}],"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=cover"},{"name":"theme-color","content":"#cdda32"},{"name":"color-scheme","content":"light"},{"name":"format-detection","content":"telephone=no, address=no, email=no"},{"name":"robots","content":"index,follow"},{"property":"og:type","content":"website"}],"style":[],"script":[{"key":"consent","data-cookieconsent":"ignore","children":"window.dataLayer = window.dataLayer || [];\n            function gtag() {\n              dataLayer.push(arguments)\n            }\n            gtag(\"consent\", \"default\", {\n              ad_personalization: \"denied\",\n              ad_storage: \"denied\",\n              ad_user_data: \"denied\",\n              analytics_storage: \"denied\",\n              functionality_storage: \"denied\",\n              personalization_storage: \"denied\",\n              security_storage: \"granted\",\n              wait_for_update: 500\n            });\n            gtag(\"set\", \"ads_data_redaction\", false);\n            gtag(\"set\", \"url_passthrough\", false);"},{"key":"gtag_new","data-cookieconsent":"ignore","hid":"gtag-new","children":"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f); })(window,document,'script','dataLayer', 'GTM-MMBFJRPK');","tagPriority":"after:script:consent"},{"key":"gtag_old","data-cookieconsent":"ignore","hid":"gtag-old","children":"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f); })(window,document,'script','dataLayer', 'GTM-MJ2S4W5');","tagPriority":"after:script:gtag_new"},{"key":"cookiebot","src":"https://consent.cookiebot.com/uc.js","data-cbid":"01329a2d-0b46-4689-bf00-62310677e33c","async":true,"tagPriority":"after:script:gtag_old"}],"noscript":[],"titleTemplate":"%s %separator","htmlAttrs":{}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false